import { Typography, useEventCallback } from '@mui/material';
import FilterReport from 'civil-status/components/research-report/filter';
import TableReport from 'civil-status/components/research-report/table';
import { CommonCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import { transformReportList } from 'civil-status/utils/transform-report-list';
import { transformerReportResearch } from 'civil-status/utils/transformer-report-research';
import { ReportListVM, ResearchReportVM } from 'civil-status/view-models/research-report';
import { Formik, Form } from 'formik';
import { Fragment, ReactElement, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { NewHttpResponseList } from 'shell/models/http-response';
import { ResponseReport } from 'shell/models/response-report';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import * as yup from 'yup';

const validationSchema = yup.object({
  dateStart: yup.date().nullable().typeError('Data non valida'),
  dateEnd: yup
    .date()
    .nullable()
    .typeError('Data non valida')
    .when('dateStart', (dateStart, formvalidationSchema) =>
      dateStart && dateStart?.toString() !== 'Invalid Date'
        ? formvalidationSchema.min(
            dateStart,
            'La data deve essere maggiore o uguale della Data inizio'
          )
        : formvalidationSchema.nullable()
    ),
});

const ResearchReportPage = (): ReactElement => {
  const paramsUrl = useParams();

  const idCat = paramsUrl.idCat || undefined;

  const [open, setOpen] = useState<boolean>(true);
  // filtri selezionati
  const [filterSelected, setFilterSelected] = useState<OperationObject | undefined>();
  const [tableProps, setTableProps] = useState<Record<string, number>>({
    page: 0,
    rowsPerPage: 10,
  });

  const [reportList, getReportList] = useHttpFetch<
    NewHttpResponseList<ResponseReport>,
    Array<ReportListVM>
  >(`${__ACT_API_URL__}/report/ricerca`, {
    onBootstrap: false,
    options: {
      errorCatching: true,
      method: 'GET',
      loading: true,
      data: {},
    },
    transformer: transformReportList,
  });

  const getReportListData = useEventCallback(
    (dataFilter: OperationObject, page?: number, rowsPerPage?: number) => {
      const queryParams = `${paginationListToQueryString({
        filters: dataFilter,
        orders: {},
        page: page || 0,
        rowsPerPage: rowsPerPage || 10,
      })}`;

      (
        getReportList({
          params: {},
          paramsSerializer: () => queryParams,
        }) as unknown as ResponsePromise<void>
      ).then(() => {
        // salvo i filtri dell'ultima ricerca
        setFilterSelected(dataFilter);
      });
    }
  );

  const handleSubmit = useEventCallback((values: ResearchReportVM) => {
    const dataFilter: OperationObject = transformerReportResearch(values);

    setTableProps({
      page: 0,
      rowsPerPage: 10,
    });

    getReportListData(dataFilter);
  });

  useEffect(() => {
    if (((reportList.data as Array<ReportListVM>) || []).length) {
      // se abbiamo risultato chiudere accordion dei filtri
      setOpen(false);
    }
  }, [reportList.data]);

  return (
    <Fragment>
      <Breadcrumbs
        items={[
          ...CommonCivilStatusCrumbs,
          {
            name: 'Ricerca Report',
            path: '',
          },
        ]}
      />
      <div className="pmi-pt-4 pmi-pb-3 pmi-d-flex pmi-align-items-center pmi-justify-content-between">
        <Typography
          color="secondary.main"
          style={{
            fontSize: '26px',
          }}
        >
          Ricerca Atti per stampa report
        </Typography>
      </div>
      <div className="circle" />
      <Formik
        initialValues={
          {
            idCat,
            disabledIdCat: Boolean(idCat),
            typeContent: '',
            state: '',
            codOperator: '',
            dateStart: null,
            dateEnd: null,
          } as ResearchReportVM
        }
        onSubmit={handleSubmit}
        validateOnMount
        validationSchema={validationSchema}
      >
        <Form>
          <FilterReport open={open} setOpen={setOpen} />
        </Form>
      </Formik>
      {reportList.data ? (
        ((reportList.data as Array<ReportListVM>) || [])?.length > 0 ? (
          <>
            <TableReport
              data={reportList.data as Array<ReportListVM>}
              filterSelected={filterSelected}
              getReportListData={getReportListData}
              tableProps={tableProps}
              setTableProps={setTableProps}
            />
          </>
        ) : (
          <Typography color="secondary.main">
            Nessun elemento trovato con la ricerca effettuata.
          </Typography>
        )
      ) : undefined}
    </Fragment>
  );
};

ResearchReportPage.displayName = 'Research Report Page component';

export default ResearchReportPage;
